import {
    StyledToggleButtonGroup,
    ReactionCountTypography,
} from "./ReactionsList.styles";
import { ReactionListPropsType } from "./ReactionsList.types";
import { StyledToggleButton } from "./Reaction.styles";
import { ReactionsNamesEnum } from "@shared/Types/Reactions/ReactionsNamesEnum";
import { ThumbsUpLightIcon } from "@icons/ThumbsUpLightIcon";
import { ThumbsUpSolidIcon } from "@icons/ThumbsUpSolidIcon";
import { getReactionCountFromReactionsArray } from "@infrastructure/Persistence/Reactions";
import { Box } from "@mui/material";
import { ReactionsDistribution } from "../../../../Components/Post/PostActions/ReactionsDistribution";

export function EntityReactionsListWithDefaultIcons({
    reactOnEntity,
    unsetHeight,
    customStyle,
    userReaction,
    reactions,
    reactionCountSum,
}: ReactionListPropsType) {
    const userHasLiked = userReaction === ReactionsNamesEnum.LIKE;
    const userHasDisliked = userReaction === ReactionsNamesEnum.DISLIKE;

    const likesCount = getReactionCountFromReactionsArray(
        reactions ?? [],
        ReactionsNamesEnum.LIKE,
    );
    const dislikesCount = getReactionCountFromReactionsArray(
        reactions ?? [],
        ReactionsNamesEnum.DISLIKE,
    );

    return (
        <Box position="relative">
            <StyledToggleButtonGroup style={customStyle}>
                <StyledToggleButton
                    disableFocusRipple
                    disableTouchRipple
                    value={0}
                    onClick={(e) => {
                        e.stopPropagation();
                        reactOnEntity?.(
                            ReactionsNamesEnum.LIKE,
                            userHasLiked ? "delete" : "create",
                        );
                    }}
                    unsetHeight={unsetHeight}
                >
                    {userHasLiked ? (
                        <ThumbsUpSolidIcon
                            width={"16px"}
                            height={"16px"}
                            fill="var(--community-color-primary-text)"
                        />
                    ) : (
                        <ThumbsUpLightIcon width={"16px"} height={"16px"} />
                    )}
                    <ReactionCountTypography>
                        {likesCount.toLocaleString("de-DE")}
                    </ReactionCountTypography>
                </StyledToggleButton>
                <StyledToggleButton
                    disableFocusRipple
                    disableTouchRipple
                    value={0}
                    onClick={(e) => {
                        e.stopPropagation();
                        reactOnEntity?.(
                            ReactionsNamesEnum.DISLIKE,
                            userHasDisliked ? "delete" : "create",
                        );
                    }}
                    unsetHeight={unsetHeight}
                >
                    {userHasDisliked ? (
                        <ThumbsUpSolidIcon
                            width={"16px"}
                            height={"16px"}
                            color="var(--community-color-primary-text)"
                            transform="rotate(180deg)"
                        />
                    ) : (
                        <ThumbsUpLightIcon
                            width={"16px"}
                            height={"16px"}
                            transform="rotate(180deg)"
                        />
                    )}
                    <ReactionCountTypography>
                        {dislikesCount.toLocaleString("de-DE")}
                    </ReactionCountTypography>
                </StyledToggleButton>
            </StyledToggleButtonGroup>
            {reactions && reactionCountSum > 0 ? (
                <ReactionsDistribution
                    entityReactions={reactions}
                    reactionCountSum={reactionCountSum}
                />
            ) : undefined}
        </Box>
    );
}
